import { CSSProperties } from "react";
import { theme } from "antd";

export function TimelineIcon(props: {
  style?: CSSProperties;
  size?: number;
  inactive?: boolean;
}) {
  const { token } = theme.useToken();
  const size = props.size === undefined ? 16 : props.size;
  if (size <= 20)
    return <Small style={props.style} inactive={props.inactive} />;
  return (
    <svg
      width="27"
      height="20"
      viewBox="0 0 108 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.9646 63.5C94.9879 63.3367 95 63.1698 95 63C95 62.8302 94.9879 62.6633 94.9646 62.5H105V63.5H94.9646ZM88.0354 63.5H70.6312C70.6546 63.3367 70.6667 63.1698 70.6667 63C70.6667 62.8302 70.6546 62.6633 70.6312 62.5H88.0354C88.0121 62.6633 88 62.8302 88 63C88 63.1698 88.0121 63.3367 88.0354 63.5ZM46.2979 63.5H63.7021C63.6788 63.3367 63.6667 63.1698 63.6667 63C63.6667 62.8302 63.6788 62.6633 63.7021 62.5H46.2979C46.3212 62.6633 46.3333 62.8302 46.3333 63C46.3333 63.1698 46.3212 63.3367 46.2979 63.5ZM39.3688 63.5H21.9646C21.9879 63.3367 22 63.1698 22 63C22 62.8302 21.9879 62.6633 21.9646 62.5H39.3688C39.3454 62.6633 39.3333 62.8302 39.3333 63C39.3333 63.1698 39.3454 63.3367 39.3688 63.5ZM3 63.5H15.0354C15.0121 63.3367 15 63.1698 15 63C15 62.8302 15.0121 62.6633 15.0354 62.5H3V63.5Z"
        fill={token.colorText}
      />
      <path d="M102 57L105 63L102 69" stroke={token.colorText} />
      <rect
        width="16"
        height="16"
        transform="translate(10 25)"
        fill={token.colorText}
      />
      <circle cx="18.5" cy="63" r="2" stroke={token.colorText} />
      <line
        opacity="0.25"
        x1="18.5"
        y1="43"
        x2="18.5"
        y2="57"
        stroke={token.colorText}
      />
      <rect
        width="16"
        height="16"
        transform="translate(34.3334 6)"
        fill={token.colorText}
      />
      <circle cx="42.8334" cy="63" r="2" stroke={token.colorText} />
      <line
        opacity="0.25"
        x1="42.8334"
        y1="24"
        x2="42.8334"
        y2="57"
        stroke={token.colorText}
      />
      <rect
        width="16"
        height="16"
        transform="translate(58.6666 22)"
        fill={token.colorText}
      />
      <circle cx="67.1666" cy="63" r="2" stroke={token.colorText} />
      <line
        opacity="0.25"
        x1="67.1666"
        y1="40"
        x2="67.1666"
        y2="57"
        stroke={token.colorText}
      />
      <rect
        width="16"
        height="16"
        transform="translate(83 31)"
        fill={token.colorText}
      />
      <circle cx="91.5" cy="63" r="2" stroke={token.colorText} />
      <line
        opacity="0.25"
        x1="91.5"
        y1="49"
        x2="91.5"
        y2="57"
        stroke={token.colorText}
      />
    </svg>
  );
}

function Small(props: { style?: CSSProperties; inactive?: boolean }) {
  const { token } = theme.useToken();
  if (props.inactive) return <Inactive style={props.style} />;
  return (
    <svg
      style={props.style}
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9646 9.5C17.9879 9.3367 18 9.1698 18 9C18 8.8302 17.9879 8.6633 17.9646 8.5H20V9.5H17.9646ZM14.0354 9.5H10.6312C10.6546 9.3367 10.6667 9.1698 10.6667 9C10.6667 8.8302 10.6546 8.6633 10.6312 8.5H14.0354C14.0121 8.6633 14 8.8302 14 9C14 9.1698 14.0121 9.3367 14.0354 9.5ZM6.2979 9.5H9.7021C9.6788 9.3367 9.6667 9.1698 9.6667 9C9.6667 8.8302 9.6788 8.6633 9.7021 8.5H6.2979C6.3212 8.6633 6.3333 8.8302 6.3333 9C6.3333 9.1698 6.3212 9.3367 6.2979 9.5ZM3.3688 9.5H0.9646C0.9879 9.3367 1 9.1698 1 9C1 8.8302 0.9879 8.6633 0.9646 8.5H3.3688C3.3454 8.6633 3.3333 8.8302 3.3333 9C3.3333 9.1698 3.3454 9.3367 3.3688 9.5Z"
        fill={token.colorText}
      />
      <path d="M19 7L20 9L19 11" stroke={token.colorText} />
      <rect
        width="4"
        height="4"
        transform="translate(2 4)"
        fill={token.colorText}
      />
      <circle cx="3.5" cy="9" r="0.5" stroke={token.colorText} />
      <line
        opacity="0.25"
        x1="3.5"
        y1="6"
        x2="3.5"
        y2="8"
        stroke={token.colorText}
      />
      <rect
        width="4"
        height="4"
        transform="translate(6 1)"
        fill={token.colorText}
      />
      <circle cx="7.5" cy="9" r="0.5" stroke={token.colorText} />
      <line
        opacity="0.25"
        x1="7.5"
        y1="3"
        x2="7.5"
        y2="8"
        stroke={token.colorText}
      />
      <rect
        width="4"
        height="4"
        transform="translate(10 3)"
        fill={token.colorText}
      />
      <circle cx="11.5" cy="9" r="0.5" stroke={token.colorText} />
      <line
        opacity="0.25"
        x1="11.5"
        y1="5"
        x2="11.5"
        y2="8"
        stroke={token.colorText}
      />
      <rect
        width="4"
        height="4"
        transform="translate(14 5)"
        fill={token.colorText}
      />
      <circle cx="15.5" cy="9" r="0.5" stroke={token.colorText} />
      <line
        opacity="0.25"
        x1="15.5"
        y1="7"
        x2="15.5"
        y2="8"
        stroke={token.colorText}
      />
    </svg>
  );
}

function Inactive(props: { style?: CSSProperties }) {
  const { token } = theme.useToken();
  return (
    <svg
      style={props.style}
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9646 9.5C17.9879 9.3367 18 9.1698 18 9C18 8.8302 17.9879 8.6633 17.9646 8.5H20V9.5H17.9646ZM14.0354 9.5H10.6312C10.6546 9.3367 10.6667 9.1698 10.6667 9C10.6667 8.8302 10.6546 8.6633 10.6312 8.5H14.0354C14.0121 8.6633 14 8.8302 14 9C14 9.1698 14.0121 9.3367 14.0354 9.5ZM6.2979 9.5H9.7021C9.6788 9.3367 9.6667 9.1698 9.6667 9C9.6667 8.8302 9.6788 8.6633 9.7021 8.5H6.2979C6.3212 8.6633 6.3333 8.8302 6.3333 9C6.3333 9.1698 6.3212 9.3367 6.2979 9.5ZM3.3688 9.5H0.9646C0.9879 9.3367 1 9.1698 1 9C1 8.8302 0.9879 8.6633 0.9646 8.5H3.3688C3.3454 8.6633 3.3333 8.8302 3.3333 9C3.3333 9.1698 3.3454 9.3367 3.3688 9.5Z"
        fill={token.colorTextTertiary}
      />
      <path d="M19 7L20 9L19 11" stroke={token.colorTextTertiary} />
      <rect
        width="4"
        height="4"
        transform="translate(2 4)"
        fill={token.colorTextTertiary}
      />
      <circle cx="3.5" cy="9" r="0.5" stroke={token.colorTextTertiary} />
      <line
        opacity="0.25"
        x1="3.5"
        y1="6"
        x2="3.5"
        y2="8"
        stroke={token.colorTextTertiary}
      />
      <rect
        width="4"
        height="4"
        transform="translate(6 1)"
        fill={token.colorTextTertiary}
      />
      <circle cx="7.5" cy="9" r="0.5" stroke={token.colorTextTertiary} />
      <line
        opacity="0.25"
        x1="7.5"
        y1="3"
        x2="7.5"
        y2="8"
        stroke={token.colorTextTertiary}
      />
      <rect
        width="4"
        height="4"
        transform="translate(10 3)"
        fill={token.colorTextTertiary}
      />
      <circle cx="11.5" cy="9" r="0.5" stroke={token.colorTextTertiary} />
      <line
        opacity="0.25"
        x1="11.5"
        y1="5"
        x2="11.5"
        y2="8"
        stroke={token.colorTextTertiary}
      />
      <rect
        width="4"
        height="4"
        transform="translate(14 5)"
        fill={token.colorTextTertiary}
      />
      <circle cx="15.5" cy="9" r="0.5" stroke={token.colorTextTertiary} />
      <line
        opacity="0.25"
        x1="15.5"
        y1="7"
        x2="15.5"
        y2="8"
        stroke={token.colorTextTertiary}
      />
    </svg>
  );
}
